import useStateControls from '../../../../../hooks/useStateControls';

export default function useCallRedirect({ redirect }) {
  const { setState } = useStateControls();
  return {
    callRedirect() {
      redirect && setState(redirect);
    },
  };
}
